import { Fragment } from 'react';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { ProductConfigurationDetailContent } from '../components/ProductConfigurationDetail/ProductConfigurationDetailContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const ProductConfigurationDetail: PageWithLayout = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Produktkonfiguration Detail | Starjack Admin</title>
            </Helmet>

            <ProductConfigurationDetailContent />
        </Fragment>
    );
};

ProductConfigurationDetail.isProtected = true;

ProductConfigurationDetail.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);
ProductConfigurationDetail.permissions = [
    Permission.LIFTOPERATOR_CONFIGURATION_NAV,
];

export default ProductConfigurationDetail;
